import { render } from "./DemoDisclaimer.vue?vue&type=template&id=33523c2b&scoped=true"
import script from "./DemoDisclaimer.vue?vue&type=script&lang=js"
export * from "./DemoDisclaimer.vue?vue&type=script&lang=js"

import "./DemoDisclaimer.vue?vue&type=style&index=0&id=33523c2b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33523c2b"]])

export default __exports__